export class PixDevolutionRequest {
	descricao: string;
	numeroOrigem: number;
	codigoTransacao: number;
	valor: number;
	tipoCanalIniciacao: string;
	codigoRequisicao: string;
	dataAgendamento: string;
	horaAgendamento: number;
	timeOut: number;
	nome: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/devolution-request.mode.ts